"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contracts = void 0;
var events_1 = require("events");
var AuthenticatedProxy_json_1 = __importDefault(require("../abi/AuthenticatedProxy.json"));
var ERC20_json_1 = __importDefault(require("../abi/ERC20.json"));
var ERC721v3_json_1 = __importDefault(require("../abi/ERC721v3.json"));
var ERC1155_json_1 = __importDefault(require("../abi/ERC1155.json"));
var APENFTSharedAsset_json_1 = __importDefault(require("../abi/APENFTSharedAsset.json"));
var APENFTExchange_json_1 = __importDefault(require("../abi/APENFTExchange.json"));
var ExchangeHelper_json_1 = __importDefault(require("../abi/ExchangeHelper.json"));
var ERC20AssetProxy_json_1 = __importDefault(require("../abi/ERC20AssetProxy.json"));
var FactoryContract_json_1 = __importDefault(require("../abi/FactoryContract.json"));
var config_1 = require("../config");
var tokens_1 = require("../tokens");
var Contracts = /** @class */ (function (_super) {
    __extends(Contracts, _super);
    function Contracts(web3, apiConfig) {
        var _this = _super.call(this) || this;
        _this.TRX = {
            name: 'tron',
            symbol: 'TRX',
            address: config_1.NULL_ADDRESS,
            decimals: 6
        };
        var networkName = apiConfig.networkName;
        _this.paymentTokenList = tokens_1.tokens[networkName].otherTokens;
        _this.networkName = networkName;
        var contracts = config_1.CONTRACTS_ADDRESSES[networkName];
        var exchangeHelperAddr = contracts.ExchangeHelper;
        var exchangeAddr = contracts.APENFTExchange;
        var APENFTSharedAssetAddr = contracts.APENFTSharedAsset;
        var APENFTExchangeKeeperAddr = contracts.APENFTExchangeKeeper;
        var feeRecipientAddress = contracts.FeeRecipientAddress;
        var wtrxAddr = contracts.WTRX;
        var erc20AssetProxyAddr = contracts.ERC20AssetProxy;
        var erc721AssetProxyAddr = contracts.ERC721AssetProxy;
        var erc1155AssetProxyAddr = contracts.ERC1155AssetProxy;
        var factoryContractAddr = contracts.FactoryContract;
        _this.contractsAddr = contracts;
        _this.WTRXAddr = wtrxAddr;
        _this.WTRXToken = {
            name: 'tron',
            symbol: 'WTRX',
            address: wtrxAddr,
            decimals: 18
        };
        _this.APENFTSharedAssetAddr = APENFTSharedAssetAddr;
        _this.APENFTExchangeKeeperAddr = APENFTExchangeKeeperAddr;
        _this.feeRecipientAddress = feeRecipientAddress;
        _this.erc20AssetProxyAddr = erc20AssetProxyAddr;
        _this.erc721AssetProxyAddr = erc721AssetProxyAddr;
        _this.erc1155AssetProxyAddr = erc1155AssetProxyAddr;
        _this.factoryContractAddr = factoryContractAddr;
        if (exchangeHelperAddr && exchangeAddr) {
            _this.exchangeHelper = web3.contract(ExchangeHelper_json_1.default.abi, exchangeHelperAddr);
            _this.exchange = web3.contract(APENFTExchange_json_1.default.abi, exchangeAddr);
            _this.erc20AssetProxy = web3.contract(ERC20AssetProxy_json_1.default.abi, erc20AssetProxyAddr);
            _this.APENFTSharedAsset = web3.contract(APENFTSharedAsset_json_1.default.abi, APENFTSharedAssetAddr);
            if (factoryContractAddr && factoryContractAddr.length > 0) {
                _this.factoryContract = web3.contract(FactoryContract_json_1.default.abi, factoryContractAddr);
            }
            // abi
            _this.erc20 = web3.contract(ERC20_json_1.default.abi);
            _this.erc721 = web3.contract(ERC721v3_json_1.default.abi);
            _this.erc1155 = web3.contract(ERC1155_json_1.default.abi);
            // config
            _this.authenticatedProxy = web3.contract(AuthenticatedProxy_json_1.default.abi);
            _this.web3 = web3;
            web3.contract().constructor.prototype.clone = function () {
                return new this.constructor(this.tronWeb, this.abi, this.address);
            };
        }
        else {
            throw new Error("".concat(_this.networkName, "  abi undefined"));
        }
        return _this;
    }
    return Contracts;
}(events_1.EventEmitter));
exports.Contracts = Contracts;
